import type { DndClass } from '../../../types/content'
import barbarian from './barbarian.json'
import bard from './bard.json'
import cleric from './cleric.json'
import druid from './druid.json'
import fighter from './fighter.json'
import monk from './monk.json'
import paladin from './paladin.json'
import ranger from './ranger.json'
import rogue from './rogue.json'
import sorcerer from './sorcerer.json'
import warlock from './warlock.json'
import wizard from './wizard.json'

export const SRD_CLASSES = [barbarian, bard, cleric, druid, fighter, monk, paladin, ranger, rogue, sorcerer, warlock, wizard] as unknown as DndClass[]
